import { collection, getCountFromServer, query, where } from "firebase/firestore";
import { firestore } from "../../config/firebase";

const getInvestmentPromosUsagesByCampaign = async (id) => {
    const invPromosUsageCollection = collection(firestore, "investmentPromosUsage");
    const q = query(invPromosUsageCollection, where("campaignId", "==", id));
    const snapshot = await getCountFromServer(q);

    return snapshot.data().count;
    
}
export default getInvestmentPromosUsagesByCampaign;